<template>
  <div class="via-controls">
    <div class="collapse-button" @click="toggle()">
      <transition name="fade" mode="out-in">
        <font-awesome-icon :key="menuIsActive" :icon="menuIsActive ? icons.close : icons.menu" />
      </transition>
    </div>
    <div class="menu-wrapper" :style="styleObject">
      <div class="menu">
        <template v-for="(grp, idx_g, idx_i) in filtered">
          <p class="menu-label" :key="idx_g">
            {{ $resx("Controls.Labels." + idx_g) }}
          </p>
          <ul class="menu-list" :key="idx_i">
            <li><a v-for="(item, idx) in grp" :key="idx" @click.prevent="toggle(), activateModal(idx_g, idx)" :disabled="disabled.includes(item.toLowerCase())">{{ $resx("Controls.Items." + item) }}</a></li>
          </ul>
        </template>
        <div class="divider"></div>
        <ul class="menu-list">
          <li><a class="button is-info" @click.prevent="toggle(), activatePublishModal()">{{ $resx("Controls.Items.Publish") }}</a></li>
          <li><a class="button is-danger" @click.prevent="$store.dispatch('logout')">{{ $resx("Controls.Items.LogOut") }}</a></li>
        </ul>
      </div>
    </div>
    <via-modal :active.sync="modalActive" :size="(filtered[group][selected] === 'Themes' ? 'xl' : 'lg')" @close="closeModal" :closeOnBackdrop="!closeDisabled" :title="$resx('Controls.Items.' + filtered[group][selected])">
      <template slot="body">
        <component v-bind:is="'modal-content-' + filtered[group][selected].toLowerCase()" @canClose="disableClose" @close="modalActive = false"></component>
      </template>
      <template slot="footer">
        <button class="button is-danger is-pulled-right" :disabled="closeDisabled">{{ $resx("Buttons.Close") }}</button>
      </template>
    </via-modal>
    <via-modal :active.sync="publishModal" size="lg" @close="publishModal = false" :closeOnBackdrop="true" :title="$resx('Controls.Items.Publish')">
      <template slot="body">
        <modal-content-publish @setPublishData="setPublishData" @lastMoment="setLastPublishMoment"></modal-content-publish>
      </template>
      <template slot="footer">
        <button class="button" @click.prevent="resetPublish()">{{ $resx("Buttons.Cancel") }}</button>
        <button class="button is-primary is-pulled-right" :disabled="publishEnabled" @click.prevent="publish()">{{ $resx("Controls.Items.Publish") }}</button>
      </template>
    </via-modal>
  </div>
</template>

<script>

import { faChevronLeft, faChevronRight, faTimes, faBars } from '@fortawesome/pro-solid-svg-icons'
import viaModal from '@/components/Modal.vue'
import modalContentPages from '@/components/admin/modals/ContentPages.vue'
import modalContentThemes from '@/components/admin/modals/ContentThemes.vue'
import modalContentDownloads from '@/components/admin/modals/ContentDownloads.vue'
import modalContentHeader from '@/components/admin/modals/ContentHeader.vue'
import modalContentBlocks from '@/components/admin/modals/ContentBlocks.vue'
import modalContentPartners from '@/components/admin/modals/ContentPartners.vue'
import modalContentStaff from '@/components/admin/modals/ContentStaff.vue'
import modalContentSettings from '@/components/admin/modals/ContentSettings.vue'
import modalContentPublish from '@/components/admin/modals/ContentPublish.vue'

import { confirm } from '@/mixins/confirm.js'

export default {
  name: 'adminControls',
  mixins: [confirm],
  data () {
    return {
      websiteTheme: process.env.VUE_APP_THEME,
      showTheme: false,
      icons: {
        right: faChevronRight,
        left: faChevronLeft,
        close: faTimes,
        menu: faBars
      },
      publishData: {},
      lastPublishMoment: new Date(),
      menuIsActive: false,
      publishModal: false,
      width: '0',
      modalActive: false,
      disabled: [],
      closeDisabled: false,
      publishEnabled: false,
      group: 'General',
      selected: 0,
      modals: {
        General: ['Pages'], // 'Settings'
        Pages: ['Header', 'Blocks'],
        Content: ['Themes', 'Downloads', 'Partners', 'Staff']
      }
      // hiddenModals: {
      //   via: [],
      //   star: ['Themes', 'Staff'],
      //   conaset: ['Themes', 'Staff']
      // }
    }
  },
  components: {
    viaModal,
    modalContentPages,
    modalContentThemes,
    modalContentDownloads,
    modalContentBlocks,
    modalContentHeader,
    modalContentPartners,
    modalContentStaff,
    modalContentSettings,
    modalContentPublish
  },
  computed: {
    styleObject () {
      return {
        width: this.width + 'px'
      }
    },
    activePage () {
      return this.$store.state.activePage
    },
    filtered () {
      var self = this
      var tmp = {}
      for (var key in self.modals) {
        for (var i = 0; i < self.modals[key].length; i++) {
          if ((process.env.VUE_APP_HIDDENMENUITEMS ? process.env.VUE_APP_HIDDENMENUITEMS.split(',') : []).indexOf(self.modals[key][i]) < 0) {
            if (!tmp[key]) {
              tmp[key] = []
            }
            tmp[key].push(self.modals[key][i])
          }
        }
      }
      return tmp
    }
  },
  methods: {
    toggle: function () {
      if (this.menuIsActive) {
        this.width = '0'
      } else {
        this.width = '240'
      }
      this.menuIsActive = !this.menuIsActive
    },
    activateModal: function (grp, idx) {
      this.group = grp
      this.selected = idx
      this.modalActive = true
    },
    closeModal: function () {
      this.modalActive = false
    },
    disableClose: function (action) {
      this.closeDisabled = !action
    },
    activatePublishModal: function () {
      var self = this
      if (self.$store.state.isAdmin && self.$store.state.hasContentChanges) {
        self.confirm({
          message: self.$resx('General.UnsavedChanges'),
          buttons: [
            {
              name: self.$resx('Buttons.Ok'),
              class: 'is-pulled-right is-primary'
            }
          ]
        })
      } else {
        self.publishModal = true
      }
    },
    setPublishData: function (data) {
      var self = this
      self.publishData[data.Key] = data.Value
    },
    setLastPublishMoment: function (date) {
      var self = this
      self.lastPublishMoment = date
    },
    resetPublish: function () {
      self.publishData = {}
    },
    publish: function () {
      var self = this
      var themes = []
      var publishMoment = ''
      for (var key in self.publishData) {
        if (key !== 'PublishMoment') {
          themes.push(self.publishData[key])
        }
      }
      if (self.publishData.PublishMoment === -1 || new Date(self.publishData.PublishMoment) <= new Date()) {
        var d = self.lastPublishMoment
        d.setMinutes(d.getMinutes() + 1)
        publishMoment = d.toISOString()
      } else {
        publishMoment = self.publishData.PublishMoment
      }
      self.$store.commit('loading', true)
      self.$store.dispatch('publish', { 'PublishMoment': publishMoment, 'Themes': themes }).then(function () {
        self.resetPublish()
        self.$store.dispatch('getSitemap', true).then(function () {
          self.$store.commit('loading', false)
        })
      })
    }
  },
  watch: {
    '$route': {
      handler (to) {
        if (to.params.page === this.$store.state.homepage) {
          this.disabled = ['blocks']
        } else {
          this.disabled = []
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.via-controls{
  position: fixed;
  right: -2px;
  top: 100px;
  z-index: 1010;
  height: 0;
  overflow: visible;

  .collapse-button{
    position: relative;
    width: 50px;
    height: 50px;
    background-color: $white;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    padding: 14px;
    text-align: center;
    border: 1px solid $grey-lighter;
    border-right: 0;
    margin-right: -1px;
    border-radius: 4px 0 0 4px;
    z-index: 1;
  }
  .menu-wrapper{
    position: relative;
    display: inline-block;
    width: 0px;
    min-height: 300px;
    height: auto;
    background-color: $white;
    vertical-align: top;
    overflow: hidden;
    transition: width .2s ease-in-out;
    border: 1px solid $grey-lighter;
    border-bottom-left-radius: 4px;
    box-shadow: 0px 4px 12px -8px $grey-dark;
    box-sizing: border-box;
    z-index: 0;

    .menu{
      padding: 20px;
      width: 240px;

      .divider{
        margin: 10px 0px;
        border-bottom: 1px solid $grey-bg;
      }

      li{
        a{
          &[disabled]{
            pointer-events: none;
            opacity: .65;
          }
          &.button{
            border-radius: 4px;
            display: block;
            padding-bottom: calc(0.375em - 1px);
            padding-left: 0.75em;
            padding-right: 0.75em;
            padding-top: calc(0.375em - 1px);
          }
        }
         + li{
           a.button{
             margin-top: 10px;
           }
         }
      }
    }
  }
}

</style>
